import { api } from "../index";
import { PaginatedResponse } from "../types";

export interface AdminCommentAutor {
  user_id: number;
  nome_completo?: string;
}

export interface AdminCommentDTO {
  comentario_id: number;
  assunto?: string;
  conteudo?: string;
  colaboracao_id: number;
  created_at?: string; // ISO
  autor?: AdminCommentAutor | null; // pode vir null se SET NULL
}

// Rotas REST definitivas (backend padronizado) - com paginação
export async function listCommentsByCollaboration(
  colaboracaoId: number,
  token: string,
  page: number = 1,
  pageSize: number = 20
): Promise<PaginatedResponse<AdminCommentDTO>> {
  if (!Number.isFinite(colaboracaoId)) {
    return { items: [], total: 0, page: 1, pageSize: 20, totalPages: 0 };
  }
  const r = await api.get(`/colaboracoes/${colaboracaoId}/comentarios`, {
    params: { page, pageSize },
    headers: { "X-CSRF-Token": token },
  });
  const data = r.data as PaginatedResponse<AdminCommentDTO>;
  return Array.isArray(data.items) ? data : { items: [], total: 0, page: 1, pageSize: 20, totalPages: 0 };
}

export async function createComment(
  colaboracaoId: number,
  data: { assunto?: string; conteudo: string },
  token: string
) {
  const r = await api.post(`/colaboracoes/${colaboracaoId}/comentarios`, data, {
    headers: { "X-CSRF-Token": token },
  });
  return r.data as AdminCommentDTO;
}

export async function updateComment(
  commentId: number,
  data: { assunto?: string; conteudo: string },
  token: string
) {
  const r = await api.patch(`/comentarios/${commentId}`, data, {
    headers: { "X-CSRF-Token": token },
  });
  return r.data as AdminCommentDTO;
}

export async function deleteComment(commentId: number, token: string) {
  await api.delete(`/comentarios/${commentId}`, {
    headers: { "X-CSRF-Token": token },
  });
  return true;
}
